<template>
  <div class="col-12 h-100 pt-2">
    <!-- issue tracker page -->
    <div class="issues-list" v-if="issues && issues.length>0">
      <div class="row issue-item align-items-center" v-for="issue in issues" :key="issue._id" @click="viewIssueDetails(issue._id)">
        <div class="col-8">
          <h6 class="issue-title">{{ issue.title}}</h6>
          <div class="issue-description"> {{issue.description}} </div>
          <div class="issue-date"> {{getFormatedDate(issue.created)}} </div>
        </div>
        <div class="col-4 issue-status">
          <badge v-if="issue.latestStatus == 'Created'" type="info">
            <span>Submitted</span>
          </badge>
          <badge v-if="issue.latestStatus == 'Closed'" type="success">
            <span>Resolved</span>
          </badge>
        </div>
      </div>
      <infinite-loading spinner="waveDots" @infinite="getIssues">
        <span slot="no-more">No more issues</span>
        <span slot="no-results"></span>
      </infinite-loading>
    </div>
    <n-button type="primary" round size="lg" @click.native="
                  goToCreateNewIssue()
                " style="
                  top: auto;
                  bottom: 0px;
                  left: 50%;
                  transform: translateX(-50%);
                  position: fixed;
                  width: 15em;
                ">
      <i class="fa fa-plus pr-1"></i>
      <!-- {{ $t("message.New Appointment") }} -->
      {{ $t("message.Report new issue") }}
    </n-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      issues: [],
      issuesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
    };
  },

  async mounted() {
    try {
      await this.getIssues();
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    goToCreateNewIssue() {
      this.$router.push("/createissue");
    },

    async getIssues($state) {
      try {
        if (!$state) {
          this.issues = [];
          this.issuesPagination = {
            pageNumber: 1,
            totalPages: 0,
          };
        }

        let response = await this.$store.dispatch("getIssuesByUser", {
          userId: this.user._id,
          pageNumber: this.issuesPagination.pageNumber,
          pageSize: 4,
        });

        if (response.data && response.data.length) {
          this.issues.push(...response.data);
          this.issuesPagination.totalPages = response.totalPages;
          this.issuesPagination.pageNumber += 1;
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }
      } catch (error) {
        console.log(error);
      }
    },

    viewIssueDetails(issueId) {
      this.$router.push("viewissue/" + issueId);
    },

    getFormatedDate(date) {
      let timestamp = Date.parse(date);
      return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm a");
    },
  },
};
</script>

<style scoped>
.issues-list {
  padding: 0 1em;
  height: 80vh;
}

.issue-item {
  padding: 0.5em 0;
  margin-top: 00.2em;
  /* background: antiquewhite; */
  border-bottom: 0.2px grey solid;
  height: 5em;
  align-content: center;
}

.issue-title,
.issue-description {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.issue-title {
  margin-bottom: 0;
}

.issue-date {
  margin-top: 0.5rem;
  font-size: x-small;
}

.issue-resolved {
  color: #18ce0f;
}

.issue-open {
  color: orange;
}
</style>
